import 'css-chunksrc/client/scenes/wbs/styles.scss';export default {
  "elementCreationForm": "_elementCreationForm_ftdfl_1",
  "draggable": "_draggable_ftdfl_10",
  "placeholder": "_placeholder_ftdfl_14",
  "load": "_load_ftdfl_1"
};